import VLButton from "@/components/VLButton/VLButton";
import { Input, Select } from "@arco-design/web-react";
import { IconSearch, IconSwap } from "@arco-design/web-react/icon";
import { Fragment, ReactNode, useEffect, useState } from "react";
import change_auto from "@/assets/create-space/change_auto.png";

import "./SearchOpeator.less";
import {
  change_bottom_icon,
  change_top_icon,
} from "@/assets/creationscriptimage";
export interface ISearchOpeator {
  tabList?: { name: string; id: number | undefined }[];
  buttonList?: ReactNode;
  disabled?: boolean;
  tabListActiveId: number | undefined;
  keyword?: string;
  filteFiled?: string;
  filterOption?: { label: string; value: string }[];
  sc?: string /** desc 和 asc*/;
  handleTabButtonClick?: (index: number) => void;
  handleKeyWordsChange?: (keyword: string) => void;
  handleScChange?: (sc: string) => void;
  handleFilterFiledChange?: (e: string) => void;
  showFilter?: boolean
}

const SearchOpeator: React.FC<ISearchOpeator> = (prop) => {
  const {
    tabList,
    buttonList,
    handleTabButtonClick,
    disabled,
    tabListActiveId,
    keyword,
    sc,
    filteFiled,
    handleKeyWordsChange,
    handleScChange,
    handleFilterFiledChange,
    filterOption,
    showFilter = true
  } = prop;
  const [activeButtonId, setActiveButtonId] = useState(tabListActiveId);
  useEffect(() => {
    setActiveButtonId(tabListActiveId)
  }, [tabListActiveId])
  return (
    <>
      <div className="creative-space-search-wrapper">
        <div className="search-wrapper-opeate">
          {tabList ? (
            <div className="btn-toggle-wrapper" style={{ marginBottom: '10px'}}>
              {(tabList || []).map((item, index) => {
                return (
                  <Fragment key={item.id + item.name + index}>
                    <VLButton
                      disabled={disabled}
                      onClick={() => {
                        setActiveButtonId(item.id);
                        if (handleTabButtonClick) {
                          handleTabButtonClick(item.id);
                        }
                      }}
                      style={{
                        borderRadius: 4,
                        border: "none",
                        marginRight: "12px",
                        color: activeButtonId !== item.id ? "#333333" : "",
                      }}
                      type={activeButtonId === item.id ? "primary" : "text"}
                      key={item.id}>
                      {item.name}
                    </VLButton>
                  </Fragment>
                );
              })}
            </div>
          ) : (
            <></>
          )}
          <div className="opeate" style={{ marginBottom: '10px'}}>
            {buttonList}
            {showFilter ? <Input
              style={{ width: 276, marginLeft: 18, height: 38 }}
              prefix={<IconSearch />}
              value={keyword || ""}
              placeholder="请输入搜索关键字"
              onChange={(e) => {
                if (handleKeyWordsChange) {
                  handleKeyWordsChange(e);
                } else {
                  console.log("请传入handleKeyWordsChange配置项");
                }
              }}
              disabled={disabled}
            /> : <></>}

            {showFilter ? <div className="hybrid-select">
              <Select
                size="large"
                allowClear
                className={"create-space-search-filed-select"}
                style={{
                  height: 38,
                  width: "200px",
                  marginLeft: 10,
                  marginRight: 10,
                }}
                value={filteFiled}
                options={filterOption}
                placeholder="按更新时间"
                onChange={(e) => {
                  if (handleFilterFiledChange) {
                    handleFilterFiledChange(e);
                  }
                }}></Select>
              <div className="sc-middle"></div>
              <div
                className={`sc-wrapper`}
                onClick={() => {
                  if (handleScChange) {
                    handleScChange(sc === "asc" ? "desc" : "asc");
                  } else {
                    console.log("请传入handleScChange配置项");
                  }
                }}>
                <img
                  width={16}
                  src={sc !== "asc" ? change_bottom_icon : change_top_icon}
                  alt=""
                />
              </div>
            </div> : <div style={{ height: 38 }}></div>}
          </div>
        </div>
      </div>
    </>
  );
};

export default SearchOpeator;
